import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import 'whatwg-fetch';
import moment from 'moment';
import MyWallPost from './wallPost';
import WallCard from './wallCard';
import DatePicker from 'react-bootstrap-date-picker';
import ModalConfirm from '../modal/modalConfirm';
import data_wall_event from '../../../data/wall-event';
import SubNavBar from '../SubNavBar';
import InfoField from './components/InfoField';
import { Grid } from '@material-ui/core';
import withAuth from 'src/hoc/withAuth';

const apiWallShow = '/api/activityWall/show/';
const apiPostSearch = '/api/activityWall/allPosts/';
const apiPostPost = '/api/activityWall/newPost';
const apiPostShow = '/api/activityWall/showPost/';
const apiPostDelete = '/api/activityWall/deletePost/';
const allowedRelatives = {
  contact: {
    label: 'contact',
    urlGet: '/api/contact/show/',
    graphKey: 'contact',
    additionalFields: [],
  },
  customer: {
    label: 'client',
    urlGet: '/api/customer/show/',
    graphKey: 'customer',
    additionalFields: [],
  },
  deal: {
    label: 'affaire',
    urlGet: '/api/deal/show/',
    graphKey: 'deal',
    additionalFields: ['installationInfos', 'productionInfos', 'commerceInfos'],
  },
  ticket: {
    label: 'ticket',
    urlGet: '/api/ticket/show/',
    graphKey: 'ticket',
    additionalFields: [],
  },
  task: {
    label: 'tâche',
    urlGet: '/api/task/show/',
    graphKey: 'task',
    additionalFields: [],
  },
  appointment: {
    label: 'rdv',
    urlGet: '/api/appointment/show/',
    graphKey: 'appointment',
    additionalFields: [],
  },
  reminder: {
    label: 'rappel',
    urlGet: '/api/reminder/show/',
    graphKey: 'reminder',
    additionalFields: [],
  },
  note: {
    label: 'note',
    urlGet: '/api/note/show/',
    graphKey: 'note',
    additionalFields: [],
  },
  productHardware: {
    label: 'produit',
    urlGet: '/api/stepProduction/getProductHardware/',
    graphKey: 'product',
    additionalFields: [],
  },
  productVirtual: {
    label: 'produit',
    urlGet: '/api/stepProduction/getProductVirtual/',
    graphKey: 'product',
    additionalFields: [],
  },
  user: {
    label: 'utilisateur',
    urlGet: '/api/user/show/',
    graphKey: 'user',
    additionalFields: [],
  },
};

class MyWall extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fatalError: undefined,
      isModalDeleteOpen: false,
      textModal: {
        title: undefined,
        message: undefined,
      },
      postToDeleteId: undefined,
      isVisiblePost: false,
      relativeTo: undefined,
      hasWall: true,
      wallId: undefined,
      appViewNavExtended: false,
      listWall: [],
      extendPosts: {},
      filterSearch: '',
      filterPostType: 0,
      filterDateStart: null,
      filterDateEnd: moment().format('YYYY-MM-DD'),
      filterDateAsc: false,
    };

    this.getWallById = this.getWallById.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleDateChange2 = this.handleDateChange2.bind(this);
    this.handleFilterPostType = this.handleFilterPostType.bind(this);
    this.toggleFilterDateAsc = this.toggleFilterDateAsc.bind(this);
    this.toggleAppViewNavExtended = this.toggleAppViewNavExtended.bind(this);
    this.toggleMenuPost = this.toggleMenuPost.bind(this);
    this.postComment = this.postComment.bind(this);
    this.deletePost = this.deletePost.bind(this);
    this.openModalDelete = this.openModalDelete.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.updateFieldPost = this.updateFieldPost.bind(this);
    this.pinPost = this.pinPost.bind(this);
    this.refreshSearch = this.refreshSearch.bind(this);
    this.resetFilter = this.resetFilter.bind(this);
    this.resetInputSearch = this.resetInputSearch.bind(this);
    this.getWallByRelative = this.getWallByRelative.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handleDateChange(value, formattedValue) {
    this.setState({
      filterDateStart: formattedValue,
    });
  }

  handleDateChange2(value, formattedValue) {
    this.setState({
      filterDateEnd: formattedValue,
    });
  }

  handleFilterPostType(value) {
    if (value === this.state.filterPostType) {
      // reset this filter
      value = 0;
    }
    this.setState({
      filterPostType: value,
    });
  }

  toggleFilterDateAsc() {
    this.setState({
      filterDateAsc: !this.state.filterDateAsc,
    });
  }

  resetFilter() {
    this.setState({
      filterSearch: '',
      filterPostType: 0,
      filterDateStart: null,
      filterDateEnd: moment().format('YYYY-MM-DD'),
      filterDateAsc: false,
    });
  }

  resetInputSearch() {
    this.setState({
      filterSearch: '',
    });
  }

  componentDidMount() {
    if (this.props.onRelative) {
      this.getWallByRelative();
    } else {
      this.getWallById();
    }
  }

  getWallById() {
    if (this.props.match.params.id) {
      let queryURL = apiWallShow;
      let graphQL =
        '{ activityWall(activityWallId:' +
        this.props.match.params.id +
        '){ id }  ' +
        ', wallEntity(activityWallId:' +
        this.props.match.params.id +
        '){ id, type } }';
      queryURL += graphQL;
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'GET',
        })
        .then((resp) => resp.json())
        .then(
          function (data) {
            if (data['data']['activityWall'] && data['data']['wallEntity']) {
              this.setState({
                wallId: data['data']['activityWall']['id'],
                relativeTo: {
                  id: data['data']['wallEntity']['id'],
                  type: data['data']['wallEntity']['type'],
                },
              });
            } else {
              this.setState({
                hasWall: false,
              });
            }
          }.bind(this)
        )
        .catch(
          function (error) {
            console.log('erreur fetch wall entity: \n' + error);
          }.bind(this)
        );
    }
  }

  getWallByRelative() {
    if (
      this.props.match.params.relativeTo &&
      allowedRelatives[this.props.match.params.relativeTo] &&
      this.props.match.params.id
    ) {
      this.setState({ fatalError: undefined });

      let queryURL = allowedRelatives[this.props.match.params.relativeTo].urlGet;
      let graphKey = allowedRelatives[this.props.match.params.relativeTo].graphKey;

      const additionalFields = allowedRelatives[this.props.match.params.relativeTo].additionalFields;
      const additionalFieldsJoined = additionalFields.join(',');

      let graphQL = `{ ${graphKey}(id:${this.props.match.params.id}){ id, activityWall{ id }${
        additionalFieldsJoined ? ',' + additionalFieldsJoined : ''
      } } }`;

      queryURL += graphQL;
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'GET',
        })
        .then((resp) => resp.json())
        .then((data) => {
          if (data['data'][graphKey] && data['data'][graphKey]['activityWall']) {
            const fields = Object.assign(
              {},
              ...additionalFields.map((additionalField) => ({
                [additionalField]: data['data'][graphKey][additionalField],
              }))
            );

            this.setState({
              wallId: data['data'][graphKey]['activityWall']['id'],
              ...fields,
              relativeTo: {
                id: this.props.match.params.id,
                type: this.props.match.params.relativeTo,
              },
            });
          } else {
            let message = 'Erreur lors de la récupération du mur';

            if (data['errors'] && data['errors'].length > 0) {
              message = data['errors'].map((e) => e.message).join(', ');
            }

            throw new Error(message);
          }
        })
        .catch((error) => {
          this.setState({
            fatalError: error.message,
            hasWall: false,
          });
        });
    } else {
      this.setState({
        hasWall: false,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.match.params.id != this.props.match.params.id ||
      prevProps.match.params.relativeTo != this.props.match.params.relativeTo
    ) {
      this.componentDidMount();
    }

    if (
      prevState.wallId !== this.state.wallId || // reload when Wall ID is renewed
      prevState.filterSearch !== this.state.filterSearch ||
      prevState.filterPostType !== this.state.filterPostType ||
      prevState.filterDateStart != this.state.filterDateStart ||
      prevState.filterDateEnd != this.state.filterDateEnd
    ) {
      this.refreshSearch();
    }
  }

  refreshSearch() {
    let dateStart = this.state.filterDateStart
      ? '"' + moment(this.state.filterDateStart).format('YYYY-MM-DD') + '"'
      : null;
    let dateEnd = this.state.filterDateEnd ? '"' + moment(this.state.filterDateEnd).format('YYYY-MM-DD') + '"' : null;
    this.setState({ pending: true });
    let queryURL = apiPostSearch;
    let graphQL =
      '{ allPost(activityWallId:' +
      this.state.wallId +
      ', postType:' +
      this.state.filterPostType +
      ', search:"' +
      this.state.filterSearch +
      '", dateStart:' +
      dateStart +
      ', dateEnd:' +
      dateEnd +
      ')' +
      '{ hasMore, items{... on Post { id, title, text, dateCreate, attachments{ name }, creator{ user{ id, username } } } ... on Event { id, title, text, dateCreate, type, linkType, linkId, creator{ user{ id, username } } } } } }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']['allPost']['items']) {
            this.setState({
              listWall: data['data']['allPost']['items'],
            });
          }
          this.setState({
            pending: false,
          });
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch events & posts search: ' + error);
        }.bind(this)
      );
  }

  toggleAppViewNavExtended() {
    this.setState({
      appViewNavExtended: !this.state.appViewNavExtended,
    });
  }

  toggleMenuPost() {
    this.setState({
      isVisiblePost: !this.state.isVisiblePost,
    });
  }

  render() {
    const { listWall } = this.state;

    let noResult = listWall && listWall.length === 0 ? <span style={{ marginLeft: 50 }}>Aucun résultat.</span> : '';

    return (
      <div id='appView' className='div-entity'>
        <SubNavBar
          appViewNavExtended={this.state.appViewNavExtended}
          title={`Mur ${this.state.relativeTo && allowedRelatives[this.state.relativeTo.type].label}`}
          toggleAppViewNavExtended={this.toggleAppViewNavExtended}
          goBack={this.props.history.goBack}
        />

        <div id='appViewContent'>
          {!this.state.fatalError ? (
            <Fragment>
              {(this.state.relativeTo || {}).type === 'deal' && (
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4}>
                    <InfoField
                      name='commerceInfos'
                      dealId={parseInt(this.props.match.params.id)}
                      fieldValue={this.state.commerceInfos || ''}
                      onValueChange={(value) => this.setState({ commerceInfos: value })}
                      label='Infos commerce'
                      placeholder='(attente RIO, marge sup, VT faite...)'
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <InfoField
                      name='productionInfos'
                      dealId={this.props.match.params.id}
                      fieldValue={this.state.productionInfos || ''}
                      onValueChange={(value) => this.setState({ productionInfos: value })}
                      label='Infos production'
                      placeholder='(client en congés du x au x, deadline install, infos spécifiques...)'
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <InfoField
                      name='installationInfos'
                      dealId={this.props.match.params.id}
                      fieldValue={this.state.installationInfos || ''}
                      onValueChange={(value) => this.setState({ installationInfos: value })}
                      label='Infos installation'
                      placeholder='(contacter x pour infos sup, mono câblage...)'
                    />
                  </Grid>
                </Grid>
              )}

              {this.state.relativeTo && (
                <Link to={'/dashboard/' + this.state.relativeTo.type + '/' + this.state.relativeTo.id}>
                  <span className='icon icon-arrow-bold-right text-clickable'>
                    Voir {allowedRelatives[this.state.relativeTo.type].label} associé
                  </span>
                </Link>
              )}

              {this.state.hasWall && this.state.isVisiblePost ? (
                <div className=''>
                  <MyWallPost
                    toggleMenuPost={this.toggleMenuPost}
                    openToast={this.props.openToast}
                    onPost={(json) => this.postComment(json)}
                  />
                </div>
              ) : (
                <div className='wall-command-panel'>
                  <div className=''>
                    <div>
                      <div className='alignHorizontal'>
                        <h6>Filtrer</h6>
                        <button onClick={this.resetFilter} type='button' className='btn btn-sm btn-outline-success'>
                          <span className='icon icon-cross' />
                        </button>
                      </div>
                      <div className='alignHorizontal'>
                        <DatePicker
                          calendarContainer={this}
                          name='filterDateStart'
                          value={this.state.filterDateStart}
                          onChange={this.handleDateChange}
                          dateFormat='YYYY-MM-DD'
                        />
                        <span className='icon icon-arrow-right' />
                        <DatePicker
                          calendarContainer={this}
                          name='filterDateEnd'
                          value={this.state.filterDateEnd}
                          onChange={this.handleDateChange2}
                          dateFormat='YYYY-MM-DD'
                        />
                        <button
                          onClick={this.toggleFilterDateAsc}
                          type='button'
                          className='btn btn-sm btn-outline-success'
                        >
                          <span
                            className={'cursor icon icon-triangle-' + (this.state.filterDateAsc ? 'up ' : 'down ')}
                          />
                        </button>
                      </div>
                      <div className='custom-search-input'>
                        <div className='input-group'>
                          <input
                            name='filterSearch'
                            value={this.state.filterSearch}
                            onChange={this.handleInputChange}
                            type='text'
                            className='search-query form-control'
                            placeholder='Recherche'
                          />
                          <span onClick={this.resetInputSearch} className='input-group-btn'>
                            <button className='btn' type='button'>
                              <span className='icon icon-cross' />
                            </button>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <button onClick={this.toggleMenuPost} type='button' className='btn btn-xl btn-success'>
                      <span className={'icon icon-chat'} />
                      Commenter
                    </button>
                  </div>
                  <div>
                    <div className='checkbox-bubble-menu'>
                      {data_wall_event &&
                        Object.entries(data_wall_event).map(([key, data]) => (
                          <div
                            key={key}
                            onClick={() => this.handleFilterPostType(data.id)}
                            className={'checkbox-bubble ' + (this.state.filterPostType === data.id ? 'selected ' : '')}
                            title={data.fr}
                          >
                            <span className={'icon icon-' + data.icon} />
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              )}

              {this.state.hasWall ? (
                <ul className='timelineV'>
                  {listWall ? (
                    listWall
                      .sort((a, b) =>
                        this.state.filterDateAsc
                          ? new Date(a.dateCreate) - new Date(b.dateCreate)
                          : new Date(b.dateCreate) - new Date(a.dateCreate)
                      )
                      .map((data) => (
                        <WallCard key={data.id} data={data} pinPost={this.pinPost} deletePost={this.openModalDelete} />
                      ))
                  ) : (
                    <li className='list-group-item'>Chargement...</li>
                  )}
                  {noResult}
                </ul>
              ) : (
                this.state.relativeTo && (
                  <span>Ce {allowedRelatives[this.state.relativeTo.type].label} n'as pas de mur</span>
                )
              )}
            </Fragment>
          ) : (
            <div className='alert alert-danger' role='alert'>
              {this.state.fatalError}
            </div>
          )}
        </div>

        <ModalConfirm
          className='myModal'
          modalText={this.state.textModal}
          isOpen={this.state.isModalDeleteOpen}
          onSubmit={this.deletePost}
          onClose={this.closeModal}
          onCancel={this.closeModal}
        />
      </div>
    );
  }

  openModalDelete(postId) {
    let modal = {
      title: 'Suppression',
      message: 'Vous allez supprimer ce commentaire',
    };
    this.props.toggleBlackOut();
    this.setState({
      postToDeleteId: postId,
      textModal: modal,
      isModalDeleteOpen: true,
      appViewNavExtended: false,
    });
  }

  closeModal() {
    this.props.toggleBlackOut();
    this.setState({
      isModalDeleteOpen: false,
    });
  }

  postComment(json) {
    if (this.state.wallId) {
      json['activityWall'] = {
        id: this.state.wallId,
      };
      json.post['nbAttachments'] = json.files.length;
      let data = '';
      if (json.files && json.files.length > 0) {
        for (let i = 0; i < json.files.length; i++) {
          let name = json.files[i].name.split('.')[0];
          let type = json.files[i].type.split('/')[1];
          let base64 = json.files[i].base64.split('base64,')[1];

          let payload = {
            filename: name,
            typeOfFile: type,
          };

          data += 'metadata-' + (i + 1) + '=' + encodeURIComponent(JSON.stringify(payload));
          data += '&';
          data += 'base64-' + (i + 1) + '=' + encodeURIComponent(base64);
          data += '&';
        }
      }
      json.files = undefined;
      data += 'data=' + encodeURIComponent(JSON.stringify(json));

      this.props
        .authFetch(apiPostPost, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          method: 'POST',
          body: data,
        })
        .then((resp) => resp.json())
        .then((data) => {
          if (data.isValid) {
            this.props.openToast(true, 'Commentaire ajouté');
            this.refreshSearch();
          } else {
            this.props.openToast(false, 'Erreur commentaire. Veuillez réessayer');
          }
        })
        .catch(() => {
          this.props.openToast(false, 'Erreur commentaire. Veuillez réessayer');
        });
    }
  }

  deletePost() {
    let queryURL = apiPostDelete;
    let json = {
      post: {
        id: this.state.postToDeleteId,
      },
    };
    queryURL += encodeURIComponent(JSON.stringify(json));
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'DELETE',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['isValid'] == true) {
            this.props.openToast(true, 'Le commentaire a bien été supprimé');
            this.refreshSearch();
          } else {
            this.props.openToast(false, 'Erreur suppression du commentaire');
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch delete post: \n' + error);
          this.props.openToast(false, 'Suppression impossible');
        }.bind(this)
      );
  }

  isPinned(title) {
    return title && title.startsWith('/*PINNED*/');
  }

  pinPost(post) {
    let newTitle = this.isPinned(post.title) ? post.title.slice(10) : '/*PINNED*/' + (post.title || 'Commentaire');
    this.updateFieldPost(post.id, newTitle, 'text', 'title');
  }

  updateFieldPost(id, newValue, inputType, fieldName) {
    let newValueSent;
    if (inputType == 'text') {
      newValueSent = '"' + newValue.replace(/["]/g, '\\"') + '"';
    } else {
      newValueSent = newValue;
    }
    let graphQL = 'mutation { post(id:' + id + ', ';
    graphQL += fieldName + ':' + newValueSent + ') { ' + fieldName + ' } }';

    let queryURL = apiPostShow;
    let data = 'data=' + encodeURIComponent(graphQL);
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
        body: data,
      })
      .then((resp) => resp.json())
      .then((data) => {
        if (data['data']['post'][fieldName] == newValue) {
          this.props.openToast(true, 'Votre modification a bien été prise en compte.');
          this.refreshSearch();
        } else {
          this.props.openToast(false, 'Erreur lors de la modification. Veuillez réessayer.');
        }
      });
  }
}

export default withAuth(MyWall);
